import type { JobListing } from "#/types/types";

export default function jobItem({
  job,
  title,
  index = 0,
}: {
  job: JobListing;
  title: string;
  index?: number;
}) {
  return (
    <article
      className="rounded-lg border border-stone-400 bg-white p-5"
      itemType="http://schema.org/ListItem"
      itemProp="itemListElement"
      itemScope
      role="button"
      aria-expanded="false"
      aria-controls="job-details-drawer"
      aria-label={`View more details for ${job.positionTitle}`}
      tabIndex={++index}
    >
      <h2
        className="mb-3 border-b border-stone-200 pb-2 text-xl font-bold"
        itemProp="name"
      >
        {title}
      </h2>
      <div className="text-sm">{job.hospital}</div>
      <div className="space-y-1">
        <h3 className="mt-1 font-bold">Job Responsibilities</h3>
        <ul className="list-inside list-disc ">
          {job.responsibilities.map((detail: string) => {
            return <li className="m-0">{detail}</li>;
          })}
        </ul>

        <h3 className="mt-1 font-bold">Salary & Benefits</h3>
        <ul className="list-inside list-disc ">
          {job.benefits.map((detail: string) => {
            return <li className="m-0">{detail}</li>;
          })}
        </ul>

        <h3 className="mt-3 font-bold">Team Highlights</h3>
        <ul className="list-inside list-disc">
          {job.teamDetails.map((detail: string) => {
            return <li className="m-0">{detail}</li>;
          })}
        </ul>
      </div>

      <div className="mt-3">
        <button
          type="button"
          aria-haspopup="dialog"
          aria-label={`Apply for ${job.positionTitle} position`}
          className="rounded-lg bg-sky-500 px-4 py-2 text-center text-sm font-medium text-white hover:bg-sky-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          {`Apply for ${job.positionTitle}`}
        </button>
      </div>
    </article>
  );
}
